import Column from 'components/Column'
import { NotificationType } from 'data/App/types'
import React from 'react'
import styled from 'styled-components'
import { zIndex } from 'utils'

import Notification from './Notification'

const Wrapper = styled(Column)`
  position: fixed;
  margin: 1rem;
  bottom: 0;
  left: 0;
  z-index: ${zIndex(5)};

  & > div:not(:first-child) {
    margin-top: 1rem;
  }
`

type PropsType = {
  readonly data: Array<NotificationType>
  readonly onClose: (type: NotificationType) => void
}

const Notifications = ({ data, onClose }: PropsType) => (
  <Wrapper>
    {data.map((notif) => (
      <Notification content={notif} key={notif.created} onClose={onClose} />
    ))}
  </Wrapper>
)

export default Notifications
